/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { removeInvitationFromOrg } from './invitation.remove.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  invitationId: undefined,
  dialog: { open: false },
  error: undefined,
};

/* Slice */
export const removeInvitationFromOrgSlice = createSlice({
  name: 'removeInvitation',
  initialState,
  reducers: {
    toggleDialog(state, action) {
      state.dialog.open = action.payload;
    },
    updateInvitationId(state, action) {
      state.invitationId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(removeInvitationFromOrg.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(removeInvitationFromOrg.fulfilled, (state) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.dialog.open = false;
        state.error = undefined;
      })
      .addCase(removeInvitationFromOrg.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectRemoveInvitationSlice = state => state[removeInvitationFromOrgSlice.name];

export const selectDialog = createSelector(selectRemoveInvitationSlice, s => s.dialog);
export const selectStatus = createSelector(selectRemoveInvitationSlice, s => s.status);
export const selectInvitationId = createSelector(selectRemoveInvitationSlice, s => s.invitationId);

/* Actions */
export const { toggleDialog, updateInvitationId } = removeInvitationFromOrgSlice.actions;
